import React from 'react';
import { KFLCheckbox, KFLRadioButton } from '@kamstrup/kamstrup-frontend-library';
import {
  TableColumn,
  GetPkType,
  IsItemSelectedType,
  ToggleItemType,
  ToggleSelectAllType,
} from './model';
import EksKFLWrapper from '../../components/shared/eks-lib/eksKFLwrapper';

const multiselectCol: TableColumn = {
  id: 'datatableCheckboxColumn',
  Header: () => '',
  sortable: false,
  width: 45,
  style: { textAlign: 'center' },
  accessor: () => '',
};

const getRowCheckbox = (
  id: string,
  checked: boolean,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
) => (
  <EksKFLWrapper>
    <KFLCheckbox
      id={`dt-select-cb-${id}`}
      checked={checked}
      onChange={onChange}
    />
  </EksKFLWrapper>
);

const getRowRadioBtn = (
  id: string,
  checked: boolean,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
) => (
  <KFLRadioButton
    id={`dt-select-cb-${id}`}
    name="customerRB"
    checked={checked}
    onChange={onChange}
  />
);

const getSelectColumnDefinition = <T extends {}>(
  selectAll: boolean,
  toggleSelectAll: ToggleSelectAllType,
  toggleItem: ToggleItemType<T>,
  isItemSelected: IsItemSelectedType<T>,
  getPk: GetPkType<T>,
  multiSelect = true
): TableColumn => {
  const Header = () =>
    multiSelect ? getRowCheckbox('header', selectAll, toggleSelectAll) : '';
  const accessor = (x: T) =>
    multiSelect
      ? getRowCheckbox(getPk(x), isItemSelected(x), () => toggleItem(x))
      : getRowRadioBtn(getPk(x), isItemSelected(x), () => toggleItem(x));

  return { ...multiselectCol, Header, accessor } as TableColumn;
};

export default getSelectColumnDefinition;
